export default __webpack_public_path__ + "static/media/Cuprum-Regular.5f942110.ttf";